import { memo, SyntheticEvent } from "react";
import { TextArea, TextAreaProps } from "semantic-ui-react";
import { ActionPostBroadcast } from "./MeCastType";

type ModBroadcastApprovalActionProps = {
  action: ActionPostBroadcast | null;
  confirmMessage?: string;
  remark: string | number;
  onChangeRemark: (e: SyntheticEvent | null, data: TextAreaProps) => void;
};

const ModBroadcastApprovalAction = (props: ModBroadcastApprovalActionProps) => {
  return (
    <div
      style={{
        padding: "1rem 1rem 0rem 1rem"
      }}
    >
      {props.action === "APPROVE" && (
        <p style={{ textAlign: "center" }}>
          "Instant post will be sent immediately.
          <br />
          Scheduled posts will be sent at the set date and time."
        </p>
      )}

      {props.action === "CANCEL" && (
        <p style={{ textAlign: "center" }}>
          If you cancel it, the status will change to Cancelled.
        </p>
      )}

      {
        // todo --- Cancel Review Condition (Ref. ConfirmModal: 45 - 55) ต้องไล่ดูว่ามีตรงไหนเรียกใช้ ConfirmModal อีก
      }

      {props.confirmMessage && (
        <p
          style={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "15px",
          }}
        >
          {props.confirmMessage}
        </p>
      )}

      {props.action === "REJECT" && (
        <p>
          Please specify reason <span style={{ color: "red" }}>*</span>
          <TextArea
            name="rejectRemark"
            value={props.remark}
            onChange={props.onChangeRemark}
            placeholder="Please specify reason"
            style={{ width: "100%", padding: "5px", resize: "none", marginTop: "5px" }}
          />
        </p>
      )}
    </div>
  );
};

ModBroadcastApprovalAction.displayName = "ModBroadcastApprovalAction";

export default memo(ModBroadcastApprovalAction);